import type { Page } from '../../types';
import { disposalDepartmentItems } from './data';

const coverSheet: Page[] = [
  {
    pageType: 'information',
    title: 'Before you start',
    name: 'before-you-start',
    description:
      "This return supports Office of Government Property analysis and reporting against the Autumn Budget 2024 commitment to raise at least GBP1 billion of capital receipts from surplus property disposals between 2025 and 2030.<br /><br />The workbook guidance says this return requires sign off by an appropriate SCS and asks departments to refresh forecast pipeline information for material sites, while also recording unconditional sales completed in the reporting window.<br /><br />Use the pages in this form to capture the same disposal fields described in the workbook's Data Field Descriptors tab.",
  },
  {
    pageType: 'question',
    title: 'Return details',
    name: 'return-details',
    description:
      'Select the central government organisation for which this disposal record is being submitted.',
    questions: [
      {
        questionType: 'textInput',
        title: 'Your contact email address',
        name: 'contact-email-address',
        hint: 'Please enter your email address.',
        userEmail: true,
        rules: {
          required: true,
          email: true,
        },
      },
      {
        questionType: 'reportMonth',
        title: 'Reporting Period',
        name: 'reporting-period',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'autoComplete',
        title: 'Department/ALB',
        name: 'department',
        hint:
          'If the organisation is not listed, select the most appropriate parent department and explain the detail in comments if needed.',
        items: disposalDepartmentItems,
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default coverSheet;
